const defaultState = {
  list: [],
  item: null,
  loaded: false,
}


const students = (state = defaultState, action) => {
  switch (action.type) {
    case 'GET_STUDENTS':
      return {...state, list: action.data, loaded: true,}
    case 'ADD_STUDENT':
        return {
          ...state, 
          list: [...state.list, {...action.data, number: state.list.length + 1}],
          loaded: true,
        }  
    case 'DELETE_STUDENT':
      return {...state, list: state.list.filter(item => item.id != action.data), loaded: true,}  
    case 'SET_KEY_STUDENT':
      return {...state, [action.key]: action.data}  
    default:
      return state;
  }
}

export default students;


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/redux/reducers/students.js